export default "__VITE_ASSET__B7Hi0ij$__"